import React from 'react';
import ConversionItemContent from './ConversionItemContent/ConversionItemContent.container';
import { useI18n } from 'utils/I18n/context';

const ConversionItemPage = () => {
    const { t } = useI18n();
    const staticNames = t?.conversionItemPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <ConversionItemContent />
            </section>
        </React.Fragment>
    );
};

export default ConversionItemPage;
